import { React } from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { decrement, increment } from "./features/counterSlice";
import { Button } from "react-bootstrap"
// import style from './Home.css'

const Home = () => {
    const count = useSelector((state) => state.counter.value);
    const email = useSelector((state) => state.user.email);
    const dispatch = useDispatch();
    return(
        <div className="d-flex flex-column align-items-center">
            <div>
                <div className="d-flex flex-column justify-content-start mb-5">
                    <div className="d-flex flex-column mb-3">
                        <span className="display-2 mt-3 text-dark">Hi, {email}</span>
                        <span className="display-4 mt-5 text-dark">{count}</span>
                    </div>
                    <div>
                        <Button className="mb-3 me-5 pe-4 ps-4" onClick={() => dispatch(increment())}>
                            +
                        </Button>
                        <Button className="mb-3 mb-3 pe-4 ps-4" onClick={() => dispatch(decrement())}>
                            -
                        </Button>
                    </div>
                </div>
                <Link className="me-5" to="/animal-page">
                    <button className="btn btn-primary">Animal Page</button>
                </Link>
                <Link to="/form-page">
                    <button className="me-5 btn btn-primary">Form Page</button>
                </Link>
                <Link to="/read-article">
                    <button className="me-5 btn btn-info">Read Article</button>
                </Link>
                <Link to="/create-article">
                    <button className="me-5 btn btn-primary">Create Article</button>
                </Link>
                <Link to="/delete-article">
                    <button className="me-5 btn btn-primary">Delete Article</button>
                </Link>
            </div>
        </div>
    );
}

export default Home;